export const ITEMS_PER_PAGE_OPTIONS = [10, 50, 200, -1];
export const ITEMS_PER_PAGE_OPTIONS_SERVE_SIDE = ITEMS_PER_PAGE_OPTIONS.slice(0,-1);

export default ITEMS_PER_PAGE_OPTIONS;
